import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Form, Field, reduxForm } from 'redux-form';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';
import { FormReduxInput } from 'client/components/Form/FormRedux';
import BeFormFieldErrors from 'client/components/Be/BeFormFieldErrors';

class EndpointAzureOpenAiSystemSettingsForm extends Component {

  static propTypes = {
    onSubmit: propTypes.func.isRequired,
  }

  fieldProps = {base: 'endpointAzureOpenAiSystemSettingsForm', metaOptions: {defaultState: null, ignorePristine: false}}

  render() {
    const { handleSubmit, onSubmit, submitting, invalid, error } = this.props;
    return (
      <Form className="group-border-dashed" onSubmit={handleSubmit(onSubmit)}>
        <BeFormFieldErrors className="xs-mt-0 xs-mb-10" errors={error} />
        <Field
          {...this.fieldProps}
          name="apiUrl"
          component={FormReduxInput}
          type="text"
          label="API URL"
          helpText="Example: https://itsaoai.openai.azure.com/openai/deployments/ITS_FIRST_AI/extensions/chat/completions?api-version=2023-08-01-preview"
          required
        />
        <Field
          {...this.fieldProps}
          name="apiKey"
          component={FormReduxInput}
          type="text"
          label="API key"
          helpText="Example: zq06S32f6Nhz9oKi4fdvSLvfnOYHAzH0"
          required
        />
        <div className="text-right">
          <ButtonWaiting type="submit" disabled={invalid} className="btn btn-primary btn-lg" isWaiting={submitting}>Save</ButtonWaiting>
        </div>
      </Form>
    );
  }

}

export default reduxForm({
  form: 'endpointAzureOpenAiSystemSettingsForm',
  enableReinitialize: true
})(EndpointAzureOpenAiSystemSettingsForm);

